import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { pub, setCookie, API } from "@/lib/api";

const SIZES = [
  { id: "feed", label: "FEED 4:5", dims: "1080×1350" },
  { id: "story", label: "STORIES 9:16", dims: "1080×1920" },
];

function PosterView({ id, k }) {
  const [state, setState] = useState("loading");
  const [serial, setSerial] = useState("");
  useEffect(() => {
    pub.get(`/poster/${id}`, { params: { k } }).then((r) => { setSerial(r.data.serial); setState("ok"); }).catch(() => setState("gone"));
  }, [id, k]);
  if (state === "loading") return <div className="w1 flex min-h-screen items-center justify-center"><span className="w1-cursor" /></div>;
  if (state === "gone") return <div className="w1 flex min-h-screen items-center justify-center font-mono text-sm text-[var(--w1-muted)]" data-testid="poster-not-found">FILE NOT FOUND</div>;
  const src = (s, dl) => `${API}/public/poster/${id}/${s}.jpg?k=${encodeURIComponent(k)}${dl ? "&dl=true" : ""}`;
  return (
    <div className="w1 min-h-screen px-5 py-10 font-mono sm:px-10" data-testid="poster-page">
      <div className="mx-auto max-w-[760px]">
      <div className="text-xs tracking-[0.3em] text-[var(--w1-blue-dim)]">SIG//333 · FILE</div>
      <h1 className="mt-2 text-2xl text-[var(--w1-blue)] sm:text-3xl" data-testid="poster-serial">{serial}</h1>
      <p className="mt-2 max-w-xl text-sm text-[var(--w1-muted)]">This is what they're circulating. Two sizes — always current.</p>
      <div className="mt-8 flex flex-wrap items-start gap-8">
        {SIZES.map((s) => (
          <div key={s.id} className="space-y-3" data-testid={`poster-size-${s.id}`}>
            <img src={src(s.id)} alt={`${serial} ${s.label}`} data-testid={`poster-img-${s.id}`}
              className="h-auto w-[300px] border border-[var(--w1-border)] sm:w-[340px]" />
            <div className="flex items-center justify-between gap-3 text-xs">
              <span className="text-[var(--w1-muted)]">{s.label} · {s.dims}</span>
              <a href={src(s.id, true)} data-testid={`poster-download-${s.id}`}
                className="border border-[var(--w1-blue-dim)] px-3 py-1.5 text-[var(--w1-blue)] transition-colors hover:bg-[var(--w1-blue)] hover:text-black">DOWNLOAD</a>
            </div>
          </div>
        ))}
      </div>
      <VideoDownload id={id} k={k} />
      <div className="mt-10 text-xs text-[var(--w1-amber)]">— M</div>
      </div>
    </div>
  );
}

function VideoDownload({ id, k }) {
  const [st, setSt] = useState("idle");
  const [err, setErr] = useState("");
  const go = async () => {
    setSt("busy"); setErr("");
    try {
      await pub.post(`/poster/${id}/video`, null, { params: { k }, timeout: 120000 });
      setSt("ready");
      window.location.href = `${API}/public/poster/${id}/story.mp4?k=${encodeURIComponent(k)}&dl=true`;
    } catch (e) {
      setSt("idle");
      setErr(e?.response?.status === 429 ? "Video limit reached for today — try again tomorrow." : "Transmission failed — try again.");
    }
  };
  return (
    <div className="mt-8 border-t border-[var(--w1-border)] pt-6 text-xs" data-testid="poster-video">
      <div className="text-[var(--w1-muted)]">STORY VIDEO · 9:16 · 6 s LOOP</div>
      <button type="button" onClick={go} disabled={st === "busy"} data-testid="poster-download-video"
        className="mt-3 border border-[var(--w1-amber)] px-4 py-2 text-[var(--w1-amber)] transition-colors hover:bg-[var(--w1-amber)] hover:text-black disabled:opacity-60">
        {st === "busy" ? "RENDERING… (UP TO 20 s)" : st === "ready" ? "DOWNLOAD AGAIN" : "DOWNLOAD STORY VIDEO"}
      </button>
      {err && <div className="mt-2 text-red-400" data-testid="poster-video-error">{err}</div>}
    </div>
  );
}

export default function SharePage() {
  const { id } = useParams();
  const [q] = useSearchParams();
  const k = q.get("k");
  const nav = useNavigate();
  useEffect(() => {
    if (k) return;
    pub.post("/visit", { ref: id }).then((r) => { setCookie("sos_code", r.data.code); setCookie("sos_src", "share"); })
      .finally(() => nav("/", { replace: true }));
  }, [id, k, nav]);
  if (k) return <PosterView id={id} k={k} />;
  return <div className="w1 flex items-center justify-center"><span className="w1-cursor" /></div>;
}
